import { render, staticRenderFns } from "./PageScroller.vue?vue&type=template&id=2ed5e348&scoped=true"
import script from "./PageScroller.vue?vue&type=script&lang=js"
export * from "./PageScroller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5e348",
  null
  
)

export default component.exports